/*
- This code defines a PopupForm class that creates a pop-up form on a webpage.
- The class constructor takes three parameters: formWrapper, buttons, and body.
formWrapper is a CSS selector for the element that wraps the pop-up form.
buttons is a CSS selector for the button elements that open and close the form.
body is a CSS selector for the body element of the webpage.
- Inside the constructor, the document.querySelector() method is used to select
the element specified by formWrapper and assign it to the popupForm property of the class.
If popupForm is successfully selected, the document.querySelectorAll() method is used to select all
the elements specified by buttons and assign them to the buttons property.
- If buttons is not an empty array, a for...of loop is used to iterate over each button in buttons and
add a click event listener to it.
The event listener calls the toggleForm() method when a button is clicked.
- The toggleForm() method toggles the active class on the popupForm element, which makes the form visible or hidden. It also toggles the overflow-hidden class on the element specified by body, which prevents the page from scrolling when the form is open.
- To use this code, you will also need to render the form with {% render 'popup-form', formId: formId, formData: formData, formHeading: 'Get help' %} and {% render 'load-css', stylesheet: 'component-popup-form' %}
*/

class PopupForm {
  constructor(formWrapper, buttons, body) {
    this.popupForm = document.querySelector(formWrapper);
    if (this.popupForm) {
      this.buttons = document.querySelectorAll(buttons);
      console.log('this.buttons', this.buttons);
      if (this.buttons.length > 0) {
        for (const button of this.buttons) {
          button.addEventListener('click', () => {
            this.toggleForm(body);
            // Toggle aria-expanded attribute
            const expanded = this.popupForm.classList.contains('active');
            for (const btn of this.buttons) {
              btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            }
          });
        }
      }
    }
  }

  toggleForm(body) {
    this.popupForm.classList.toggle('active');
    console.log(this.popupForm);
    document.querySelector(body).classList.toggle('overflow-hidden');
    const headerContent = document.querySelector('.header-content');
    const gaiaHeader = document.querySelector('gaia-header');
    if (headerContent) {
      const isOpen = this.popupForm.classList.contains('active');
      if (isOpen) {
        headerContent.classList.add('header--hidden');
        headerContent.style.top = `${0 - headerContent.offsetHeight}px`;
        if (gaiaHeader) gaiaHeader.style.setProperty('z-index', '1', 'important');
      } else {
        headerContent.classList.remove('header--hidden');
        headerContent.style.top = '0px';
        if (gaiaHeader) gaiaHeader.style.removeProperty('z-index');
      }
    }
    // Toggle aria-expanded attribute after toggling form
    if (this.buttons) {
      const expanded = this.popupForm.classList.contains('active');
      for (const btn of this.buttons) {
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }
  }
}
